/** SVG-капля 32×40, заливка [color], для ymaps Placemark default#image */
export function mapPinDataUrl(fill: string, options?: { stroke?: string }): string {
  const stroke = options?.stroke ?? 'rgba(0,0,0,0.35)'
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="40" viewBox="0 0 32 40">
  <path fill="${fill}" stroke="${stroke}" stroke-width="1.5" d="M16 2C9.4 2 4 7.1 4 13.4c0 8.2 10.5 18.8 11.2 19.5.4.4 1 .6 1.6.6h.2c.6 0 1.2-.2 1.6-.6C19 32.2 28 21.6 28 13.4 28 7.1 22.6 2 16 2z"/>
  <circle cx="16" cy="14" r="4.5" fill="rgba(255,255,255,0.35)"/>
</svg>`
  const b64 = btoa(unescape(encodeURIComponent(svg)))
  return `data:image/svg+xml;base64,${b64}`
}
